import classNames from './NotFoundContent.module.scss';
import SVG from 'react-inlinesvg';
import TheButton from '@/components/TheButton/TheButton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import search from '@/assets/svg/magnifying-glass.svg';

interface NotFoundContentProps {
  error: string;
  title: string;
  description: string;
  buttonText: string;
}

const NotFoundContent = ({ error, title, description, buttonText }: NotFoundContentProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleHomeClick = (text: string) => {
    if (text === t('homepage')) navigate('/');
    else if (text === t('back')) navigate('/login');
    else navigate('/login');
  };
  return (
    <div className={classNames.notFoundContent}>
      <SVG src={search} />
      <span className={classNames.error}>{error}</span>
      <h2>{title}</h2>
      <p dangerouslySetInnerHTML={{ __html: description }} />
      <TheButton
        className={classNames.btn}
        text={buttonText}
        shouldRecolor={false}
        emitOnClick={() => handleHomeClick(buttonText)}
      />
    </div>
  );
};

export default NotFoundContent;
